
    import '/opt/buildhome/repo/components/x-stream/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["components-x-stream-demo-default-protocol","components-x-stream-demo-custom-protocol"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/x-stream/index.en-US.md?type=demo')
};